import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Card, CardText, RaisedButton, DatePicker } from "material-ui";
import customDateTimeFormat from "../../../helpers/dateFormat";
import { OpenSolicitudEditarEliminacion, CambiarInicioVigenciaArancel } from "./actions";
import { GuardarSolicitudEditarEliminacion } from "../GrillaSolicitud/actions";
import { ObtenerTiposUnidad, ObtenerTiposPrestaciones, ObtenerItemImed, ObtenerTipoProfesional } from "../../Global/actions";
import styles from "./../../styles/styles";

class SolicitudEditarEliminacion extends React.Component {
  componentWillMount() {
    this.props.dispatch(ObtenerTiposPrestaciones());
    this.props.dispatch(ObtenerTiposUnidad());
    this.props.dispatch(ObtenerItemImed());
    this.props.dispatch(ObtenerTipoProfesional());
  }

  CloseSolicitudEditarEliminacion = () => {
    this.props.dispatch(OpenSolicitudEditarEliminacion(false, null));
  }

  CambiarInicioVigenciaArancel = (event, date) => {
    /* const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;
    let today = new Date();
    today.setDate(today.getDate() + fechaVigenciaPrestador);
    const dateMin = today;
    let dateMod = date;
    if (dateMin > date) {
      dateMod = dateMin;
      this.props.dispatch(CambiarInicioVigenciaArancel(
        dateMod,
        `La fecha no puede ser menor a ${dateMin.toLocaleDateString()}`
      ));
    } else { */
    this.props.dispatch(CambiarInicioVigenciaArancel(date/* dateMod */));
    //}
  }

  GuardarSolicitudEditarCreacion = () => {
    this.props.CambiosSinGuardar(true);
    this.props.dispatch(GuardarSolicitudEditarEliminacion(this.props.detallePrestacion));
    this.props.dispatch(OpenSolicitudEditarEliminacion(false, null));
  }

  render() {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;
    let today = new Date();
    today.setDate(today.getDate() + fechaVigenciaPrestador);
    const minDate = today;

    let glosaTipoProfesional = this.props.detallePrestacion.tipoProfesional;
    if (this.props.tiposProfesionales && this.props.tiposProfesionales.length > 0) {
      const tps = this.props.tiposProfesionales.filter((tp) => tp.Tipo === this.props.detallePrestacion.tipoProfesional);
      if (tps && tps.length > 0) { glosaTipoProfesional = tps[0].Descripcion; }
    }

    return (
      <div style={{ width: 990 }}>
        <div style={styles.frameContenidoGeneral}>
          <Card zDepth={0} style={{ paddingBottom: 0 }}>
            <CardText style={{ paddingBottom: 0 }}>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h1}>Editar línea de detalle de solicitud
                  </div>


                  <div style={styles.h3}>Eliminación
                  </div>
                </div>
              </div>
              <div className="row" style={{ paddingBottom: 0, marginTop: 15 }}>
                <div className="col-5" style={styles.colSelectFieldActualizar}>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Arancel
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.glosaTipoArancel}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Centro de Atención
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.glosaCentroAtencion}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Tipo Atención
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.tipoAtencion == "A" ? "AMBULATORIA" : "HOSPITALARIA"}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Valor
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.montoArancelPrestacion}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Unidad
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.tipoUnidad}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Código Prestación Prestador
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.codigoPrestacionPrestador}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Tipo de Prestación
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.glosaGrupoPrestador}
                    </div>
                  </div>
                </div>
                <div className="col-5" style={styles.colSelectFieldActualizar}>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Glosa Prestación Prestador
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.glosaPrestacionPrestador}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Código Fonasa Informado Prestador
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.codigoFonasa}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Item IMED
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.itemImed}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Tipo de Profesional
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {glosaTipoProfesional}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Fin Vigencia Prestación
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      <DatePicker
                        name="dp_see_inicioVigencia"
                        id="dp_see_inicioVigencia"
                        mode="landscape"
                        DateTimeFormat={customDateTimeFormat.cl()}
                        minDate={minDate}
                        locale="es-CL"
                        firstDayOfWeek={1}
                        value={new Date(this.props.detallePrestacion.inicioVigenciaArancel)}
                        errorText={this.props.detallePrestacion.inicioVigenciaArancelError}
                        onChange={this.CambiarInicioVigenciaArancel}
                        underlineStyle={styles.underlineSelectField}
                        style={styles.datepickerStyle}
                        inputStyle={styles.h4}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row" style={{ marginTop: 10, marginBottom: 10 }}>
                <div className="col-12" style={{ textAlign: "right" }}>
                  <RaisedButton
                    label="Cancelar"
                    onClick={this.CloseSolicitudEditarEliminacion}
                    backgroundColor="#fff"
                    overlayStyle={{ borderRadius: 5 }}
                    labelStyle={{
                      fontSize: "11px", color: "#757575", paddingLeft: 10, paddingRight: 5,
                    }}
                    style={{ width: "145px", borderRadius: 5 }}
                    buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                  />
                  <RaisedButton
                    label="Guardar"
                    onClick={this.GuardarSolicitudEditarCreacion}
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                    buttonStyle={{ borderRadius: 5 }}
                  />
                </div>
              </div>
            </CardText>
          </Card>
        </div>
      </div>
    );
  }
}


SolicitudEditarEliminacion.propTypes = {
  tiposProfesionales: PropTypes.array.isRequired,
  detallePrestacion: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  CambiosSinGuardar: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tiposProfesionales: state.global.tiposProfesionales,
  detallePrestacion: {
    glosaTipoArancel: state.solicitudEditarEliminacion.detallePrestacion.glosaTipoArancel,
    tipoAtencion: state.solicitudEditarEliminacion.detallePrestacion.tipoAtencion,
    glosaCentroAtencion: state.solicitudEditarEliminacion.detallePrestacion.glosaCentroAtencion,
    rowGuid: state.solicitudEditarEliminacion.detallePrestacion.rowGuid,

    montoArancelPrestacion: state.solicitudEditarEliminacion.detallePrestacion.montoArancelPrestacion,
    tipoUnidad: state.solicitudEditarEliminacion.detallePrestacion.tipoUnidad,
    codigoPrestacionPrestador: state.solicitudEditarEliminacion.detallePrestacion.codigoPrestacionPrestador,
    pabellonPrestacion: state.solicitudEditarEliminacion.detallePrestacion.pabellonPrestacion,
    glosaPrestacionPrestador: state.solicitudEditarEliminacion.detallePrestacion.glosaPrestacionPrestador,
    codigoFonasa: state.solicitudEditarEliminacion.detallePrestacion.codigoFonasa,
    itemImed: state.solicitudEditarEliminacion.detallePrestacion.itemImed,
    tipoProfesional: state.solicitudEditarEliminacion.detallePrestacion.tipoProfesional,
    inicioVigenciaArancel: state.solicitudEditarEliminacion.detallePrestacion.inicioVigenciaArancel,
    inicioVigenciaArancelError: state.solicitudEditarEliminacion.detallePrestacion.inicioVigenciaArancelError,
    tipoPrestacion: state.solicitudEditarEliminacion.detallePrestacion.tipoPrestacion,
    glosaGrupoPrestador: state.solicitudEditarEliminacion.detallePrestacion.glosaGrupoPrestador,
  },
  ENV: state.global.ENV,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudEditarEliminacion);
